module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "also-read-wrapper"
  }, [_c('div', {
    class: ("also-read-article-wrapper " + (_vm.article.isLast ? 'last': ''))
  }, [_c('span', {
    staticClass: "also-read-tag"
  }, [_vm._v("also read")]), _c('div', {
    staticClass: "also-read-content",
    attrs: {
      "gtm-event-category": "Scroll Article"
    }
  }, [(_vm.article.layoutType === 3) ? _c('article-level-three', {
    attrs: {
      "node": _vm.article.node
    }
  }) : _c('article-level-four', {
    attrs: {
      "node": _vm.article.node
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13fa9f8d","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/AlsoRead.vue
// module id = 1044
// module chunks = 1 3 4 5